export const SURVEY_URL = 'https://dialogluzern.ch/processes/Aufwertungwaldstaetterstrasse/f/626/';

export const LATITUDE = 47.0460091;
export const LONGITUDE = 8.3072841;

export const HOUR_MIN = 6;
export const HOUR_MAX = 22;
